import type { TrackedButtonClickName } from '~/services/gtm.client';
import gtm from '~/services/gtm.client';

import UserEvent from './UserEvent';

type EventData = {
  buttonName: TrackedButtonClickName;
  isBot: boolean;
  pagePosition: string;
};

class RegisterIntentEvent extends UserEvent<EventData> {
  sendToGtm() {
    gtm.pushToDataLayer({
      button_name: this.data.buttonName,
      event: 'register_intent',
      page_position: this.data.pagePosition
    });
  }
}

export default RegisterIntentEvent;
